export default "__VITE_ASSET__BJcirGQK__"